import IobService from "../../../Services/IobService";

export default class IobInvoiceViewDescription {
    static invoiceService = IobService.GetInvoiceById;
    static title = "IOB Invoice Preview";
    static fileNamePrefix = "iob_invoice";
    static attachInvoiceServiceFunction = IobService.AttachReportAsync;
}